var React = require('react');

function LuxeCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 6.98661L5.93459 11L16 1","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round"}));
}

LuxeCheck.defaultProps = {"width":"17","height":"12","viewBox":"0 0 17 12","fill":"none"};

module.exports = LuxeCheck;

LuxeCheck.default = LuxeCheck;
